export const throttle = (fn, ms) => {
  let throttling = false;

  return function _throttle() {
    if (!throttling) {
      throttling = true;
      // eslint-disable-next-line prefer-rest-params
      fn(...arguments);
      setTimeout(() => (throttling = false), ms);
    }
  };
};

export const debounceHead = (fn, ms) => {
  // eslint-disable-next-line init-declarations
  let timeout;

  return function _debounce() {
    if (!timeout) {
      // eslint-disable-next-line prefer-rest-params
      fn(...arguments);
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => (timeout = false), ms);
  };
};

export const debounceTail = (fn, ms) => {
  // eslint-disable-next-line init-declarations
  let timeout;

  return function _debounce() {
    clearTimeout(timeout);
    // eslint-disable-next-line prefer-rest-params
    timeout = setTimeout(() => fn(...arguments), ms);
  };
};

export const raf = (fn) => {
  // eslint-disable-next-line no-shadow,init-declarations
  let raf;

  return function _raf() {
    cancelAnimationFrame(raf);
    // eslint-disable-next-line prefer-rest-params
    raf = requestAnimationFrame(() => fn(...arguments));
  };
};

export const listenOnce = (target, event, fn) => {
  const _fn = function () {
    // eslint-disable-next-line prefer-rest-params
    fn(...arguments);
    target.removeEventListener(event, _fn);
  };
  return target.addEventListener(event, _fn);
};

export const dispatchEvent = (source, event, options = { bubbles: true, cancelable: true }) => {
  try {
    source.dispatchEvent(new Event(event, options));
  } catch (_) {
    const e = document.createEvent('Event');
    e.initEvent(event, options.bubbles, options.cancelable);
    source.dispatchEvent(e);
  }
};
